// Values stored on orders.distance_integration_type — mirrors DISTANCE_API in onward-functions
// (src/lib/jobs/constants.js).
export const DISTANCE_API = {
    GOOGLE: 'GMAPS',
    PC_MILER: 'PCM',
};

// Display labels for the stored value. Only a non-default engine is worth calling out, so Google
// has no label and its orders render the distance alone. Shippers and carriers see this, so the
// label reads as a product name rather than the internal code.
export const DISTANCE_API_LABELS = {
    [DISTANCE_API.PC_MILER]: 'PC Miler',
};
